import { Box, Button, Chip, Container, Divider, Icon, Paper, Tabs, Typography } from '@mui/material';
import CreateMember from '../../containers/CreateMember';
import * as futureSet from '../../utils/featureConstants';
import DataTable from '../common/DataTable';
import Filter from '../common/Filter';
import Header from '../common/Header/Header';
import Loading from '../common/Loading';
import NoResultsFound from '../common/NoResultsFound';
import MemberFilterModal from '../Member/MemberFilterModal';
import PartnerFilterModal from '../PartnerFilterModal';
import styles from './styles';
import { PartnerAndMemberProps } from './types';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} {...other}>
            {value === index && (
                <Box sx={{ p: 3, backgroundColor: 'none' }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const periodLabels: { [key: string]: string } = {
    Last7Days: 'Last 7 Days',
    Last15Days: 'Last 15 Days',
    Last30Days: 'Last 30 Days',
    Last90Days: 'Last 90 Days',
};

const partnerPeriodLabels: { [key: string]: string } = {
    lastWeek: 'Last 7 Days',
    lastMonth: 'Last Month',
    lastSixMonths: 'Last 6 Months',
    lastYear: 'Last Year',
};

const PartnersAndMembersManagement = ({
    user,
    partnerData,
    memberData,
    partnerColumns,
    memberColumns,
    partnerLoadMore,
    memberLoadMore,
    partnerHasMore,
    memberHasMore,
    setOpenProfileDetails,
    openProfileDetails,
    selectedStatus,
    onMemberSearchChange,
    onPartnerSearchChange,
    handleRowClick,
    selectedPeriod,
    onStatusChange,
    onPeriodChange,
    partnerAndMember,
    setPartnerAndMember,
    membersCount,
    partnersCount,
    onDiabetesTypeChange,
    onMemberPeriodChange,
    onMemberStatusChange,
    selectedMemberPeriod,
    selectedMemberStatus,
    onMemberFilterChipDelete,
    onMemberFiltersApplyClick,
    onMemberFiltersClearClick,
    onPartnerFilterChipDelete,
    onPartnerFiltersApplyClick,
    onPartnerFiltersClearClick,
    loader,
    setCreateMember,
    createMember,
    setReload,
    fromSelectedPartner,
    diabetesTypeData,
    partnerSortData,
    memberSortData,
    setPartnerCurrentPage,
    reload,
}: PartnerAndMemberProps) => {
    const onPartnerChipDelete = (type: 'status' | 'additionPeriod') => {
        if (onPartnerFilterChipDelete) {
            onPartnerFilterChipDelete(type);
        }
    };

    const onMemberChipDelete = (type: 'status' | 'diabetes' | 'additionPeriod', name?: string) => {
        if (onMemberFilterChipDelete) {
            onMemberFilterChipDelete(type, name);
        }
    };

    const chekedDiabetesType = diabetesTypeData.filter((a) => a.checked);

    return (
        <Container sx={styles.container} maxWidth={false}>
            <Header
                profileImg={user.profileImg}
                name={user.name}
                titleComponent={
                    <Typography component="div" sx={styles.header}>
                        <Typography id="partner_and_member_title" component="div" sx={styles.title}>
                            Partner & Members
                        </Typography>
                    </Typography>
                }
                setOpenProfileDetails={setOpenProfileDetails}
                openProfileDetails={openProfileDetails}
            />
            <Paper elevation={1} sx={styles.table}>
                <Typography component="div" sx={styles.partner}>
                    <Typography component="div" sx={styles.root}>
                        <Tabs
                            value={partnerAndMember}
                            TabIndicatorProps={{
                                style: styles.tabIndicator,
                            }}
                        >
                            <Typography component="div">
                                <Button
                                    id="all-Partners"
                                    variant={partnerAndMember === 0 ? 'contained' : 'outlined'}
                                    sx={styles.allPartnerButton}
                                    onClick={() => setPartnerAndMember(0)}
                                >
                                    All Partners ({partnersCount})
                                </Button>
                            </Typography>

                            <Typography component="div">
                                <Button
                                    id="all-members"
                                    variant={partnerAndMember === 1 ? 'contained' : 'outlined'}
                                    sx={styles.allMemberButton}
                                    onClick={() => {
                                        setPartnerCurrentPage(1);
                                        setPartnerAndMember(1);
                                    }}
                                >
                                    All Members ({membersCount})
                                </Button>
                            </Typography>
                        </Tabs>
                    </Typography>

                    <TabPanel value={partnerAndMember} index={0}>
                        <Typography component="div" sx={styles.member}>
                            <Typography component="div">
                                <Filter
                                    id="partner-search"
                                    onApplyFiltersClick={onPartnerFiltersApplyClick}
                                    onFiltersClearClick={onPartnerFiltersClearClick}
                                    placeholder="Search Partners..."
                                    searchChange={onPartnerSearchChange}
                                    modalContent={
                                        <PartnerFilterModal
                                            selectedStatus={selectedStatus}
                                            onStatusChange={onStatusChange}
                                            onPeriodChange={onPeriodChange}
                                            selectedPeriod={selectedPeriod}
                                        />
                                    }
                                    disabled={!futureSet.hasFeatureEnabled(futureSet.FEATURE_LEVEL.viewPartnerEmployer)}
                                />
                            </Typography>
                            <Typography component="div" sx={styles.selectedFilters}>
                                {selectedStatus && (
                                    <Chip
                                        id="statusChip"
                                        sx={styles.chip}
                                        color="primary"
                                        onDelete={() => onPartnerChipDelete('status')}
                                        label={selectedStatus === 'active' ? 'Active' : 'Inactive'}
                                        variant="outlined"
                                        deleteIcon={
                                            <Icon sx={styles.chipDelete}>
                                                <img alt="" src="./images/chip-delete.svg" />
                                            </Icon>
                                        }
                                    />
                                )}{' '}
                                {selectedPeriod && (
                                    <Chip
                                        id="periodChip"
                                        sx={styles.chip}
                                        color="primary"
                                        onDelete={() => onPartnerChipDelete('additionPeriod')}
                                        label={partnerPeriodLabels[selectedPeriod as string]}
                                        variant="outlined"
                                        deleteIcon={
                                            <Icon sx={styles.chipDelete}>
                                                <img alt="" src="./images/chip-delete.svg" />
                                            </Icon>
                                        }
                                    />
                                )}{' '}
                            </Typography>
                        </Typography>
                    </TabPanel>

                    <TabPanel value={partnerAndMember} index={1}>
                        <Typography component="div" sx={styles.member}>
                            <Typography component="div">
                                <Filter
                                    id="member-search"
                                    onApplyFiltersClick={onMemberFiltersApplyClick}
                                    onFiltersClearClick={onMemberFiltersClearClick}
                                    placeholder="Search Members..."
                                    searchChange={onMemberSearchChange}
                                    modalContent={
                                        <MemberFilterModal
                                            selectedMemberStatus={selectedMemberStatus}
                                            onMemberStatusChange={onMemberStatusChange}
                                            onMemberPeriodChange={onMemberPeriodChange}
                                            selectedMemberPeriod={selectedMemberPeriod}
                                            onDiabetesTypeChange={onDiabetesTypeChange}
                                            diabetesTypeData={diabetesTypeData}
                                        />
                                    }
                                />
                            </Typography>
                            <Typography component="div" sx={styles.selectedFilters}>
                                {selectedMemberStatus && (
                                    <Chip
                                        id="memberStatusChip"
                                        sx={styles.chip}
                                        color="primary"
                                        onDelete={() => onMemberChipDelete('status')}
                                        label={selectedMemberStatus === 'active' ? 'Active' : 'Inactive'}
                                        variant="outlined"
                                        deleteIcon={
                                            <Icon sx={styles.chipDelete}>
                                                <img alt="" src="./images/chip-delete.svg" />
                                            </Icon>
                                        }
                                    />
                                )}{' '}
                                {selectedMemberPeriod && (
                                    <Chip
                                        id="memberPeriodChip"
                                        sx={styles.chip}
                                        color="primary"
                                        onDelete={() => onMemberChipDelete('additionPeriod')}
                                        label={periodLabels[selectedMemberPeriod as string]}
                                        variant="outlined"
                                        deleteIcon={
                                            <Icon sx={styles.chipDelete}>
                                                <img alt="" src="./images/chip-delete.svg" />
                                            </Icon>
                                        }
                                    />
                                )}{' '}
                                {chekedDiabetesType.length !== 0 &&
                                    chekedDiabetesType.map((dt) => (
                                        <>
                                            <Chip
                                                key={dt.label}
                                                id="diabetesTypeChip"
                                                sx={styles.chip}
                                                color="primary"
                                                onDelete={() => onMemberChipDelete('diabetes', dt.label)}
                                                label={dt.label}
                                                variant="outlined"
                                                deleteIcon={
                                                    <Icon sx={styles.chipDelete}>
                                                        <img alt="" src="./images/chip-delete.svg" />
                                                    </Icon>
                                                }
                                            />{' '}
                                        </>
                                    ))}
                            </Typography>
                            <Typography
                                id="add_new_member"
                                sx={styles.addMember}
                                component="div"
                                onClick={() => setCreateMember(true)}
                            >
                                Add New Member
                                <Typography
                                    component="img"
                                    alt="add member"
                                    src="/images/add.svg"
                                    sx={styles.addIcon}
                                />
                            </Typography>
                        </Typography>
                    </TabPanel>
                </Typography>

                <Divider sx={styles.divider} />
                {/* eslint-disable no-nested-ternary */}
                {loader ? (
                    <Loading />
                ) : partnerAndMember === 0 &&
                  !futureSet.hasFeatureEnabled(futureSet.FEATURE_LEVEL.viewPartnerEmployer) ? (
                    <Typography component="div" sx={styles.emptyResults}>
                        Under Construction.
                    </Typography>
                ) : (partnerAndMember === 0 &&
                      futureSet.hasFeatureEnabled(futureSet.FEATURE_LEVEL.viewPartnerEmployer) &&
                      partnerData.length === 0) ||
                  (partnerAndMember === 1 && memberData.length === 0) ? (
                    <NoResultsFound />
                ) : (
                    <>
                        <TabPanel value={partnerAndMember} index={0}>
                            <DataTable
                                columns={partnerColumns}
                                data={partnerData}
                                loadMore={partnerLoadMore}
                                hasMore={partnerHasMore}
                                handleRowClick={handleRowClick}
                                sortData={partnerSortData}
                            />
                        </TabPanel>
                        <TabPanel value={partnerAndMember} index={1}>
                            <DataTable
                                columns={memberColumns}
                                data={memberData}
                                loadMore={memberLoadMore}
                                hasMore={memberHasMore}
                                sortData={memberSortData}
                            />
                        </TabPanel>
                    </>
                )}
            </Paper>
            {createMember ? (
                <CreateMember
                    createMember={createMember}
                    setCreateMember={setCreateMember}
                    setReload={setReload}
                    fromSelectedPartner={fromSelectedPartner}
                    partnerData={partnerData}
                    reload={reload}
                />
            ) : null}
        </Container>
    );
};

export default PartnersAndMembersManagement;
